import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { platformStatsFbPagePost_template } from "../components/templates/platformStatsFbPagePost_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class platformStats_fbPage_post extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected platformStats_fbPage_post: platformStatsFbPagePost_template;

    protected getModuleName(){
        return "platformStats_fbPage_post";
    }

    buildContent() : Array<Element>{

        this.platformStats_fbPage_post = new platformStatsFbPagePost_template( "platformStats_fbPage_post", this.viewModel, this );

        return [ this.platformStats_fbPage_post.build()];
    }

    public fillPage() : void{

        this.platformStats_fbPage_post.activateLoading();

        let params: Array<Array<string>> = [];
        //params.push(["data", ko.toJSON(this.home.getViewModelForRequest())] );

        let XHRHdl = new XMLHttpRequestHandler('/api/searchConsoleStats/', params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        let _myThis = this;

        XHRHdl.onReadyStateFunction = _myThis.onGetFillPageReturn;
        XHRHdl.execute();
    }


    protected onGetFillPageReturn(req: any, obj: platformStats_fbPage_post) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.platformStats_fbPage_post.setDate(responseParsed.date);
                obj.platformStats_fbPage_post.setBrands(responseParsed.brands);
                obj.platformStats_fbPage_post.setStats(responseParsed.data);
            });

            if(req.request.readyState == 4){

                obj.platformStats_fbPage_post.deactivateLoading();
            }
        };
    }

}



// WEBPACK FOOTER //
// ./js/modules/platformStats_fbPage_post.ts